module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": "/modul-belajar",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-book"
  }), _c('span', [_vm._v("Modul Belajar")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ecdc104","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modul_pembelajaran/Navigation.vue
// module id = 1280
// module chunks = 0